import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.25 12.9393L10.25 1H11.75L11.75 12.9394L16.4697 8.21967L17.5304 9.28033L11.5304 15.2803C11.2375 15.5732 10.7626 15.5732 10.4697 15.2803L4.46973 9.28033L5.53039 8.21967L10.25 12.9393ZM2.5 19.5V12.25H1V20.25C1 20.6642 1.33579 21 1.75 21H20.25C20.6642 21 21 20.6642 21 20.25V12.25H19.5V19.5H2.5Z"
    />
  </svg>
);
